import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CmsConfig, ConfigModule, I18nModule } from '@spartacus/core';
import { GenericLinkModule, NavigationModule } from '@spartacus/storefront';
import { KnBrFooterComponent } from './kn-br-footer.component';

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        NavigationModule,
        GenericLinkModule,
        I18nModule,
        ConfigModule.withConfig({
            cmsComponents: {
                FooterNavigationComponent: {
                    component: KnBrFooterComponent,
                },
            },
        } as CmsConfig),
        KnBrFooterComponent,
    ],
    exports: [KnBrFooterComponent]
})
export class KnBrFooterModule {}
